module.exports = __webpack_public_path__ + "img/GH-kyujin-top-020.3aaa4a9e.webp";